import { DictionaryUtility } from "../../../base/utilities";
import {
  IConfiguration,
  NewObjectKeys,
  IFormatEditorBehaviorFormatEditorNewObjectConfiguration,
} from "../../domain/configuration";

export class DefaultConfigurationOverwriter {
  static overwrite(source: IConfiguration): void {
    source.formatEditor = {
      behavior: {
        format: {
          editor: {
            commandManager: {
              max: 50,
            },
            newObjects: DictionaryUtility.convert(
              DefaultConfigurationOverwriter._locatorBeans,
              (k, s) => DefaultConfigurationOverwriter.toNewObjects(s)),
            object: {
              isStampable: true,
              size: {
                min: {
                  width: 20,
                  height: 20,
                },
              },
              count: {
                min: 0,
              },
              behaviors: {
                name: {
                  isEnable: true,
                  hisInformationKey: {
                    isEnable: true,
                    selectable: {
                      isEnable: true,
                    }
                  },
                  name: {
                    isEnable: true,
                  },
                  categoryName: {
                    isEnable: true,
                  },
                },
                comboSelect: {
                  isEnable: true,
                  shouldNotSelectFirst: {
                    isEnable: true,
                  },
                  optionForegroundColor: {
                    isEnable: true,
                  },
                  optionBackgroundColor: {
                    isEnable: true,
                  },
                  optionScore: {
                    isEnable: true,
                  },
                  optionPageKey: {
                    isEnable: true,
                  },
                  optionCode: {
                    isEnable: true,
                  },
                },
                fontSizeAutoAdjust: {
                  isEnable: true,
                },
                pageExtend: {
                  isEnable: true,
                },
                lineBreak: {
                  isEnable: true,
                },
                check: {
                  isEnable: true,
                  isGroupScopePage: {
                    isEnable: true,
                  },
                  isMultiCheckable: {
                    isEnable: true,
                  },
                  isChecked: {
                    isEnable: true,
                  },
                  pastedTextToCheck: {
                    isEnable: true,
                  },
                  score: {
                    isEnable: true,
                  },
                  patientProfile: {
                    isEnable: true,
                  },
                },
                freeInput: {
                  isEnable: true,
                },
                inputRule: {
                  isEnable: true,
                },
                inputMethod: {
                  isEnable: true,
                },
                focus: {
                  isEnable: true,
                },
                textSearch: {
                  isEnable: true,
                },
                naturalText: {
                  isEnable: true,
                },
                quote: {
                  isEnable: true,
                },
                print: {
                  isEnable: true,
                  shouldPrint: {
                    isEnable: true,
                  },
                  shouldPreview: {
                    isEnable: true,
                  },
                },
                edit: {
                  isEnable: true,
                },
                dateInput: {
                  isEnable: true,
                },
                emptyAlert: {
                  isEnable: true,
                },
                groupAlert: {
                  isEnable: true,
                },
                lengthAlert: {
                  isEnable: true,
                },
                numberRangeAlert: {
                  isEnable: true,
                },
                dateCalculate: {
                  isEnable: true,
                },
                copyLinkedText: {
                  isEnable: true,
                },
                tooltip: {
                  isEnable: true,
                },
                transcribe: {
                  isEnable: true,
                },
                transcribeDateOfTime: {
                  isEnable: true,
                },
                scriptExecuteTrigger: {
                  isEnable: true,
                },
                emptyAlertAllow: {
                  isEnable: true,
                },
                groupAlertAllow: {
                  isEnable: true,
                },
              },
              styles: {
                paintOnEditing: {
                  isEnable: true,
                },
                text: {
                  isEnable: true,
                  backgroundColor: {
                    isEnable: true,
                  },
                  fontName: {
                    isEnable: true,
                  },
                  fontSize: {
                    isEnable: true,
                  },
                  fontColor: {
                    isEnable: true,
                  },
                  alignment: {
                    isEnable: true,
                  },
                },
                number: {
                  isEnable: true,
                },
                turnedText: {
                  isEnable: true,
                },
                date: {
                  isEnable: true,
                  formatKind: {
                    isEnable: true,
                  },
                  hasWeekDay: {
                    isEnable: true,
                  },
                },
                time: {
                  isEnable: true,
                },
                check: {
                  isEnable: true,
                  kind: {
                    isEnable: true,
                  },
                  paint: {
                    isEnable: true,
                  },
                  border: {
                    isEnable: true,
                  },
                },
              },
            },
            attributes: {
              documentKind: {
                isEnable: true,
              },
              companyCode: {
                isEnable: true,
              },
              expirationDate: {
                isEnable: true,
              },
              indicationMagnification: {
                isEnable: true,
              },
              numberOfPrints: {
                isEnable: true,
              },
              categoryType: {
                isEnable: true,
              },
              tag: {
                isEnable: true,
              },
              inOutType: {
                isEnable: true,
              },
              masterCode: {
                maxLength: 0,
              },
            },
            workflow: {
              isEnable: true,
            },
            registerer: {
              instantCloser: {
                isEnable: false,
                waitTimeAsMsec: 3000,
                notification: {
                  isEnable: false,
                  message: "$WAITTIMEASSEC$秒後に自動的に画面を閉じます.",
                  delayAsMsec: 100,
                },
              },
              allPagesEditValidator: {
                isEnable: false,
              },
              shouldPrintSpecifiedSectionAtFirstRegistration: {
                direct: true,
                workflow: false,
              },
              postRegistration: {
                applications: [],
              },
            },
            objectLazyDrawer: {
              initialDrawItemMax: 200,
              intervalToDrawItemAsMsec: 500,
              itemCountPerDraw: 100,
            },
            handles: {
              size: {
                width: 10,
                height: 10,
              },
            },
          },
          list: {
            externalMenus: [],
            filters: {
              masterCode: {
                isEnable: true,
              },
              tag: {
                isEnable: true,
              },
              folder: {
                shouldShowEmptyFolderDefault: false,
              },
            },
          },
        },
        patient: {
          fixed: {
            code: "1",
          },
        },
      },
      style: {
        format: {
          editor: {
            objects: {
              HisText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              HisDate: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              HisTime: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              FreeText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#1d79be",
                foregroundColorCode: "#000000",
              },
              Text: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#ffcaca",
                foregroundColorCode: "#000000",
              },
              FixedText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#da80d5",
                foregroundColorCode: "#000000",
              },
              Date: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#1d79be",
                foregroundColorCode: "#000000",
              },
              Time: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#1d79be",
                foregroundColorCode: "#000000",
              },
              NumberText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#1d79be",
                foregroundColorCode: "#000000",
              },
              CheckBox: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#ff8e8e",
                foregroundColorCode: "#25a225",
              },
              CircleSelect: {
                backgroundColorCode: "transparent",
                borderColorCode: "#ff8e8e",
                foregroundColorCode: "#000000",
              },
              ComboBox: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#ffcaca",
                foregroundColorCode: "#ffcaca",
              },
              Roll: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#ffcaca",
                foregroundColorCode: "#ffcaca",
              },
              UserDefinedText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              UserDefinedDate: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              ExternalData: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              CalculateExpression: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#8d8dff",
                foregroundColorCode: "#8d8dff",
              },
              ConditionalExpression: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#b6b271",
                foregroundColorCode: "#b6b271",
              },
              DurationExpression: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#8d8dff",
                foregroundColorCode: "#8d8dff",
              },
              SpanExpression: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#8d8dff",
                foregroundColorCode: "#8d8dff",
              },
              ImageArea: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#56d356",
                foregroundColorCode: "#56d356",
                fontSize: 12.0,
              },
              Image: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#8dd38d",
                foregroundColorCode: "#ff0000",
                fontSize: 12.0,
              },
              RangeOfMotionGraph: {
                backgroundColorCode: "transparent",
                borderColorCode: "#000000",
                foregroundColorCode: "#000000",
                fontSize: 12.0,
              },
              RangeOfMotionText: {
                backgroundColorCode: "transparent",
                borderColorCode: "#ff0000",
                foregroundColorCode: "#000000",
              },
              Barcode: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#ff8e8e",
                foregroundColorCode: "#ff8e8e",
                fontSize: 12.0,
              },
              PositionCorrection: {
                backgroundColorCode: "#000000",
                borderColorCode: "#000000",
                foregroundColorCode: "#000000",
              },
              JoinedText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#e7c139",
                foregroundColorCode: "#e7c139",
              },
              Graph: {
                backgroundColorCode: "transparent",
                borderColorCode: "#000000",
                foregroundColorCode: "#1861e1",
                fontSize: 12.0,
              },
              DateCompareExpression: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#b6b271",
                foregroundColorCode: "#d1a823",
              },
              ExternalScript: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#e7c139",
                foregroundColorCode: "#000000",
                fontSize: 12.0,
              },
              DesignatedDoctorNumberText: {
                backgroundColorCode: "#ffffff",
                borderColorCode: "#d1a823",
                foregroundColorCode: "#d1a823",
              },
              NotImplemented: {
                backgroundColorCode: "#ffff00",
                borderColorCode: "#ff0000",
                foregroundColorCode: "#ff0000",
                fontSize: 12.0,
              },
            },
          },
        },
      },
      extensions: {
        questionnaire: {
          isEnable: false,
        },
      },
    };
  }

  private static toNewObjects(bean: any): IFormatEditorBehaviorFormatEditorNewObjectConfiguration {
    return {
      isEnable: true,
      source: bean,
    };
  }

  private static readonly _locatorBeans: { [key in NewObjectKeys]: any } = {
    NewHisText: {
      "@element-name": "text",
      "@name": "SRYKA_NAME",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewHisDate: {
      "@element-name": "date",
      "@name": "DISEASE_DEVELOPMENT_DATE",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "2",
      "@visible": "7",
    },
    NewHisTime: {
      "@element-name": "date",
      "@name": "PRINT_TIME",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "0",
      "@time-format": "4",
      "@visible": "112",
    },
    NewFreeText: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewText: {
      "@element-name": "tag",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewFixedText: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewDate: {
      "@element-name": "date",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "2",
      "@visible": "7",
    },
    NewTime: {
      "@element-name": "date",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "0",
      "@time-format": "4",
      "@visible": "48",
    },
    NewNumberText: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@input-code": "1",
      "@title": "",
    },
    NewCheckBox: {
      "@element-name": "check",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@quote": "0",
      "@bg": "ffffff",
      "@item-name": "",
      "@text": "",
      "@select-mode": "1",
      "@select": "0",
    },
    NewCircleSelect: {
      "@element-name": "circleselect",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@quote": "0",
      "@item-name": "",
      "@text": "",
      "@score-on": "1",
      "@ptprofile-option": "2",
      "@selected": "0",
      "@color": "000000",
      "@type": "1",
      "@border-width": "2",
    },
    NewComboBox: {
      "@element-name": "combo",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewRoll: {
      "@element-name": "roll",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewUserDefinedText: {
      "@element-name": "text",
      "@name": "",
      "@source-file": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "1",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "relational": {
        "@action": "window-type",
        "relationalitem": {
          "@option": "1",
        },
      },
    },
    NewUserDefinedDate: {
      "@element-name": "date",
      "@name": "",
      "@source-file": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "2",
      "@visible": "7",
      "relational": {
        "@action": "window-type",
        "relationalitem": {
          "@option": "1",
        },
      },
    },
    NewExternalData: {
      "@element-name": "script",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@row": "0",
      "@column": "0",
      "@exe-path": "",
      "@csv-path": "",
      "@update": "0",
    },
    NewCalculateExpression: {
      "@element-name": "calculate",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "0",
      "@form-type": "1",
      "@round": "0",
      "@decimal-place": "0",
    },
    NewConditionalExpression: {
      "@element-name": "calculate",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "1",
      "@form-type": "2",
      "@round": "0",
      "@decimal-place": "0",
    },
    NewDurationExpression: {
      "@element-name": "calculate",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "2",
      "@form-type": "3",
      "@round": "0",
      "@decimal-place": "0",
    },
    NewSpanExpression: {
      "@element-name": "calculate",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "3",
      "@form-type": "4",
      "@round": "0",
      "@decimal-place": "0",
    },
    NewImage: {
      "@element-name": "image",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
    },
    NewImageArea: {
      "@element-name": "imagearea",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
    },
    NewStamp: {
      "@element-name": "stamp",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@user-id": "",
    },
    NewRangeOfMotionGraph: {
      "@element-name": "graph",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@type": "1",
      "@orientation": "1",
      "@input": "1",
      "@scale": "1",
      "@high-value": "",
      "@low-value": "",
      "@max": "0",
      "@min": "0",
      "@muscular-strength": "1",
    },
    NewRangeOfMotionText: {
      "@element-name": "text",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewBarcode: {
      "@element-name": "barcode",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@type": "1",
      "@text": "",
      "@mode": "3",
      "@level": "1",
      "@size": "3",
    },
    NewPositionCorrection: {
      "@element-name": "poscorrect",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      "@width": "20",         // 新規オブジェクトは初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@height": "20",        // 新規オブジェクトは初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@edit": "2",
      "@quote": "0",
    },
    NewJoinedText: {
      "@element-name": "jointext",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "0",
      "@decimal-place": "0",
    },
    NewGraph: {
      "@element-name": "graph",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@type": "2",
      "@orientation": "1",
      "@input": "1",
      "@scale": "1",
      "@high-value": "",          // 使ってない模様.
      "@low-value": "",           // 使ってない模様.
      "@max": "0",
      "@min": "0",
      "@muscular-strength": "1",
    },
    NewDateCompareExpression: {
      "@element-name": "calculate",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "2",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@priority": "4",
      "@form-type": "5",
      "@round": "0",
      "@decimal-place": "0",
      "@vanish": "1",
    },
    NewExternalScript: {
      "@element-name": "scriptlink",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
      "@vanish": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@row": "0",
      "@column": "0",
      "@exe-path": "",
      "@csv-path": "",
      "@update": "6",
    },
    NewSign: {
      "@element-name": "sign",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "1",
    },
    NewDesignatedDoctorNumberText: {
      "@element-name": "text",
      "@name": "指定医番号",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "relational": [
        {
          "@action": "designate-doctor",
          "relationalitem": [
            {
              "@value-type": "1",
              "@value": "SHOUNIMANSEI",
            },
          ],
        },
      ],
    },
    NewRichText: {
      "@element-name": "richText",
      "@name": "",
      "@obj-id": "0",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
    },
    NewNewPage: {
      "@element-name": "newPage",
      "@name": "",
      "@startx": "0",
      "@starty": "0",
      "@endx": "0",
      "@endy": "0",
      "@edit": "1",
      "@hide": "1",
    },
    NewLine: {
      "@element-name": "line",
      "@name": "",
      "@startx": "0",
      "@starty": "0",
      "@endx": "20",          // 新規オブジェクトは長さの初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@endy": "20",          // 新規オブジェクトは長さの初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@edit": "2",
      "@quote": "0",
      "@type": "1",
      "@color": "000000",
      "@width": "2",
      "@arrow-size": "12",  // 使ってない模様.
    },
    NewArrorLine: {
      "@element-name": "line",
      "@name": "",
      "@startx": "0",
      "@starty": "0",
      "@endx": "20",          // 新規オブジェクトは長さの初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@endy": "20",          // 新規オブジェクトは長さの初期値0だとオフセット計算で0除算発生するので0以外を指定する事.
      "@edit": "2",
      "@quote": "0",
      "@type": "4",
      "@color": "000000",
      "@width": "2",
      "@arrow-size": "12",  // 使ってない模様.
    },
    NewBoxLine: {
      "@element-name": "boxline",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@color": "000000",
      "@type": "1",
      "@border-width": "2",
      "@texture": "0",
    },
    NewCircle: {
      "@element-name": "circle",
      "@name": "",
      // 位置は指定しても意味ないので後で補完されるのに任せる.
      // サイズも指定しても意味ないので後で補完されるのに任せる.
      "@edit": "2",
      "@quote": "0",
      "@color": "000000",
      "@type": "1",
      "@border-width": "2",
      "@texture": "0",
    },
    NewQuestionnaireGroup: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      "@edit": "2",
      "@quote": "0",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@width": "703",
      "@height": "24",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "group",
            },
          ],
        },
      ],
    },
    NewQuestionnaireDisplay: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      "@edit": "2",
      "@quote": "0",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@width": "703",
      "@height": "24",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "display",
            },
          ],
        },
      ],
    },
    NewQuestionnaireInteger: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@input-code": "1",
      "@title": "",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "integer",
            },
          ],
        },
      ],
    },
    NewQuestionnaireDate: {
      "@element-name": "date",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "2",
      "@visible": "7",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "date",
            },
          ],
        },
      ],
    },
    NewQuestionnaireDateTime: {
      "@element-name": "date",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "0",
      "@time-format": "4",
      "@visible": "48",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "dateTime",
            },
          ],
        },
      ],
    },
    NewQuestionnaireTime: {
      "@element-name": "date",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@date": "00000000",
      "@format": "0",
      "@time-format": "4",
      "@visible": "48",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "time",
            },
          ],
        },
      ],
    },
    NewQuestionnaireString: {
      "@element-name": "text",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "2",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "string"
            },
          ],
        },
      ],
    },
    NewQuestionnaireChoiceDropDown: {
      "@element-name": "combo",
      "@name": "",
      "@obj-id": "0",
      "@edit": "2",
      "@bg": "ffffff",
      "@fg": "000000",
      "@font": "12.0",
      "@font-name": "ＭＳ ゴシック",
      "@pos": "1",
      "@vpos": "2",
      "@auto-size": "1",
      "@type": "1",
      "@text": "",
      "@space-line": "-1",
      "@data-validation": "None",
      "@width": "180",
      "@height": "12",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "choice",
            },
          ],
        },
      ],
    },
    NewQuestionnaireChoiceCheckBox: {
      "@element-name": "check",
      "@name": "",
      "@obj-id": "0",
      "@edit": "1",
      "@quote": "0",
      "@bg": "ffffff",
      "@item-name": "",
      "@text": "",
      "@select-mode": "1",
      "@select": "0",
      "@width": "10",
      "@height": "10",
      "relational": [
        {
          "@action": "questionnaire",
          "relationalitem": [
            {
              "@key": "type",
              "@value": "choice",
            },
          ],
        },
      ],
    },
  };
}
